import { Button } from '@/components/_ui/Button'
import Image from 'next/image'

import type { HeaderPromotion } from '@/components/_headers/headerData'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'

type Props = {
  promotion: HeaderPromotion
}

const DesktopMenuPromotion = ({ promotion }: Props) => {
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()
  const { gtm } = useGTM()

  return (
    <div className="flex items-center">
      <Image
        className="rounded-lg"
        height={250}
        width={250}
        alt="Promotion"
        src={promotion.image}
      />

      <div className="mx-10 flex flex-col justify-center gap-3">
        <span className="bold text-md font-bold text-primary">
          {promotion.title}
        </span>
        <span className="text-sm  text-primary">{promotion.description}</span>
        <a href={parseLinkUrlWithLocale({ url: promotion.button.href })}>
          <Button
            onClick={() => {
              gtm.navbarMenuItemClicked({
                action: 'ads_learn_more',
                category: 'ads',
                ads_title: promotion.title,
                ads_image_name: promotion.image,
                ads_url: promotion.button.href,
              })

              mixpanelService
                .trackEvent(
                  MixpanelEvent.NAVIGATION_BAR_SHOP_MENU_ITEM_CLICKED,
                  {
                    action: 'ads_learn_more',
                    category: 'ads',
                    ads_title: promotion.title,
                    ads_image_name: promotion.image,
                    ads_url: promotion.button.href,
                  },
                )
                .catch(() => {})
            }}
            className="rounded-full bg-secondary"
          >
            {promotion.button.title}
            <Image
              height={20}
              width={20}
              src="/icons/arrow-long-right.svg"
              alt="arrow"
              className="ml-3"
            />
          </Button>
        </a>
      </div>
    </div>
  )
}

export default DesktopMenuPromotion
